import { ref } from 'vue';

export const useLegalPolicyDialogs = () => {
    const termsOpen = ref(false);
    const privacyOpen = ref(false);

    const openTerms = () => {
        termsOpen.value = true;
    };

    const openPrivacy = () => {
        privacyOpen.value = true;
    };

    const closeTerms = () => {
        termsOpen.value = false;
    };

    const closePrivacy = () => {
        privacyOpen.value = false;
    };

    return {
        termsOpen,
        privacyOpen,
        openTerms,
        openPrivacy,
        closeTerms,
        closePrivacy,
    };
};
